import React from 'react'
import { Tab } from 'semantic-ui-react'

import { OverviewTab, ExperienceTab, InsuranceAcceptedTab, PracticeLocationsTab } from './Tabs'

import { defaultStyles as styles } from './styles'

export const ProfileOverview = ({ provider }) => {
  return (
    <div style={styles.container}>
      <Tab
        menu={{ secondary: true, pointing: true }}
        panes={[
          {
            menuItem: 'Overview',
            render: () => (
              <div style={styles.content}>
                <OverviewTab />
              </div>
            )
          },
          {
            menuItem: 'Experience',
            render: () => (
              <div style={styles.content}>
                <ExperienceTab />
              </div>
            )
          },
          {
            menuItem: 'Insurance Accepted',
            render: () => (
              <div style={styles.content}>
                <InsuranceAcceptedTab />
              </div>
            )
          },
          {
            menuItem: 'Practice Locations',
            render: () => (
              <div style={styles.locationsContent}>
                <PracticeLocationsTab locations={provider?.locations} />
              </div>
            )
          }
        ]}
      />
    </div>
  )
}
